import { DocPrefix } from "../constants/index";
import { DocumentSearch } from "components/search/constants";

// Strips the doc-type prefix from an S12 ID (e.g. "template_abc123" → "abc123")
export const stripDocType = (docId: string): string => {
  const tokens = docId.split("_");
  return tokens.length > 1 ? tokens[1] : tokens[0];
};

export const toS12ID = (docPrefix: DocPrefix, uuid: string) => {
  return docPrefix + "_" + uuid.replace(/\-/g, "");
};

const s12PrefixRegex = new RegExp(`^(${Object.values(DocPrefix).join("|")})_`);

// toUUID generates a UUID (without dashes) from a s12ID
export const toUUID = (s12id: string): string => {
  const uuid4 = s12id.replace(s12PrefixRegex, "");
  return (
    uuid4.slice(0, 8) +
    "-" +
    uuid4.slice(8, 12) +
    "-" +
    uuid4.slice(12, 16) +
    "-" +
    uuid4.slice(16, 20) +
    "-" +
    uuid4.slice(20)
  ).trim();
};

// validateUUID will return if a uuid is in a valid format. Works with dashes or without
export function validateUUID(uuid: string): boolean {
  const pattern =
    /^(?<first>[a-fA-F\d]{8})-?(?<second>[a-fA-F\d]{4})-?(?<third>[a-fA-F\d]{4})-?(?<fourth>[a-fA-F\d]{4})-?(?<fifth>[a-fA-F\d]{12})$/i;

  return pattern.test(uuid);
}
// check if valid S12Id
export function validateS12ID(uuid: string): boolean {
  const pattern =
    /^(user|role)_(?<first>[a-fA-F\d]{8})?(?<second>[a-fA-F\d]{4})?(?<third>[a-fA-F\d]{4})?(?<fourth>[a-fA-F\d]{4})?(?<fifth>[a-fA-F\d]{12})$/i;
  return pattern.test(uuid);
}

// The following handles both formats
// uuid: e496f777ee7943da95a6a6291c73b1ca format
// uuid: e496f777-ee79-43da-95a6-a6291c73b1ca format
export const convertUUIDtoS12Id = (uuid: string, docType: string) => {
  if (
    docType === DocumentSearch.User &&
    !uuid.startsWith(DocumentSearch.User)
  ) {
    return DocumentSearch.User + uuid.replace(/-/g, "");
  }

  if (
    docType === DocumentSearch.Role &&
    !uuid.startsWith(DocumentSearch.Role)
  ) {
    return DocumentSearch.Role + uuid.replace(/-/g, "");
  }

  return uuid;
};
